// removed by extract-text-webpack-plugin
module.exports = {"classAccordionContainer":"Accordion-classAccordionContainer-5abe34b9","classAccordion":"Accordion-classAccordion-a6a8911b","classAccordionContent":"Accordion-classAccordionContent-36f5ba40","classAccordionButton":"Accordion-classAccordionButton-8bbf4262","classAccordionTitle":"Accordion-classAccordionTitle-4a25970e","toggleControl":"Accordion-toggleControl-6407be67","toggleText":"Accordion-toggleText-9ed7e560"};


//////////////////
// WEBPACK FOOTER
// ./src/themes/defaults/sass/components/Accordion.scss
// module id = 821
// module chunks = 0